import marketplaceBg from './assets/backgrounds/Registration_Marketplace.jpg';
import oauthBg from './assets/backgrounds/Registration_Oauth.gif';
import teamBg from './assets/backgrounds/Registration_Team.gif';
import background from './assets/backgrounds/background.png';
import ghStudentBg from './assets/partners/github/github_student_bg.png';
import ghStudentLogo from './assets/partners/github/github_student_logo.png';
import glitchBg from './assets/partners/glitch/glitch_bg.png';
import glitchLogo from './assets/partners/glitch/glitch_logo.png';
import lfBg from './assets/partners/lf/lf_bg.png';
import lfLogo from './assets/partners/lf/lf_logo.png';
import { ButtonVariations, VariantMap, VariantProps } from './interfaces/variant';

type RegistrationVariantsType =
  | 'primary'
  | 'marketplace'
  | 'community'
  | 'oauth_app'
  | 'team'
  | 'glitchPartner'
  | 'lfPartner'
  | 'githubStudentPack';

const defaultVariant: VariantProps = {
  id: 0,
  type: 'defaultVariant',
  background: {
    url: background,
  },
  loginTitle: 'Create your account',
  loginSubtitle: 'Start spending more time on your projects and less time managing your infrastructure.',
};

export const registrationVariants: Record<RegistrationVariantsType, VariantProps> = {
  primary: defaultVariant,
  marketplace: {
    ...defaultVariant,
    type: 'marketplace',
    background: {
      url: marketplaceBg,
    },
    loginTitle: 'Sign up & deploy – in minutes!',
    loginSubtitle: 'Marketplace solutions let you deploy with a single click!',
    metadata: {
      title: 'Your {{registrationFormData.marketplace_app.name}} app is a few steps away',
      description: 'You need to create an account on DigitalOcean',
    },
    footerTextColor: 'light',
  },

  community: {
    ...defaultVariant,
    type: 'community',
    loginSubtitle:
      'Start learning and growing with DigitalOcean’s community. Creating an account will make it easier to engage with our thousands of free tutorials and other developers in our community. As a bonus, your new account will also give you access to DigitalOcean’s cloud offerings.',
  },

  oauth_app: {
    ...defaultVariant,
    type: 'oauth',
    background: {
      url: oauthBg,
    },
    loginTitle: 'Authorization needed',
    loginSubtitle:
      'In order to use {{registrationFormData.oauth_app.name}}, you’ll need to create a DigitalOcean account.',
  },

  team: {
    ...defaultVariant,
    type: 'team',
    background: {
      url: teamBg,
    },
    loginTitle: 'Join your team on DigitalOcean!',
    loginSubtitle:
      '{{registrationFormData.team}} has invited you to join them. Sign up and start making waves with your team today!',
  },

  glitchPartner: {
    ...defaultVariant,
    type: 'glitchPartner',
    splash: {
      background: {
        url: glitchBg,
      },
      titleImage: {
        image: { url: glitchLogo },
        size: 'large',
      },
      title: {
        text: 'Deploy your project to DigitalOcean',
        color: 'dark',
      },
      subtitle: {
        text: 'Easily deploy Glitch projects on DigitalOcean’s App Platform using your project’s environment variable configuration.',
        color: 'dark',
      },

      cta: {
        text: 'Learn more',
        href: 'https://www.digitalocean.com/blog/new-droplet-console-ssh-support/',
      },
    },
  },

  lfPartner: {
    ...defaultVariant,
    type: 'lfPartner',
    splash: {
      background: {
        url: lfBg,
      },
      titleImage: {
        image: { url: lfLogo },
        size: 'large',
      },
      title: {
        text: 'Open Source Skills Development',
        color: 'dark',
      },
      subtitle: {
        text: "Linux Foundation Training & Certification offers training courses to build knowledge and skills, and certification exams to test and demonstrate learnings and capabilities, around the world's most important open source technologies, including Linux, Kubernetes, Node.js, Hyperledger, RISC-V, and much more.",
        color: 'dark',
      },
    },
  },
  githubStudentPack: {
    ...defaultVariant,
    type: 'githubStudentPack',
    loginTitle: 'Sign up for DigitalOcean',
    splash: {
      background: {
        url: ghStudentBg,
      },
      titleImage: {
        image: { url: ghStudentLogo },
      },
      title: {
        text: 'GitHub Student Developer Pack',
        color: 'dark',
      },
      subtitle: {
        text: `As a part of GitHub student developer pack, you will receive ${
          '$200' /* eslint-disable-line @do/no-hardcoded-prices */
        } in credit that are valid for 1 year. Once you sign up you will be prompted to verify your GitHub account`,
        color: 'dark',
      },

      cta: {
        variant: ButtonVariations.SECONDARY,
        text: 'Learn more',
        href: 'https://education.github.com/pack?utm_source=github+digitalocean',
      },
    },
    background: {
      color: '#eff2fb',
    },
    loginSubtitle: 'You will need to create an account by authenticating your GitHub account to claim your credits',
  },
};

export const RefcodeVariantMapping: VariantMap = {
  marketrefcode: registrationVariants.marketplace,
  '58a925265b7b': registrationVariants.glitchPartner,
  '3b1eb93990e5': registrationVariants.lfPartner,
  community: registrationVariants.community,
};
